import { Observable, throttleTime } from 'rxjs';

export function instantValidationThrottle<T>() {
    return (source$: Observable<T>): Observable<T> => source$.pipe(throttleTime(90, undefined, { leading: false, trailing: true }));
}
